export default __webpack_public_path__ + "static/side_img-873c6b5cd0e974b3dcd3e51e680fbd4f.webp";